import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getNhaCungCapState = state => state.nhaCungCap;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NHACUNGCAP_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NHACUNGCAP_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function nhaCungCapUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NHACUNGCAP_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function nhaCungCapRemoveRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NHACUNGCAP_REMOVE_API,
    formData
  )

  return handleRequest(request);
}

function* nhaCungCapListRequestFlow() {
  const nhaCungCap = yield select(getNhaCungCapState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, nhaCungCap.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nhaCungCapListSuccess(results.data))

  } catch (error) {
    yield put(brActions.nhaCungCapListError(error))
  }
}

function* nhaCungCapDetailRequestFlow() {
  const nhaCungCap = yield select(getNhaCungCapState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, nhaCungCap.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nhaCungCapDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.nhaCungCapDetailError(error))
  }
}

function* nhaCungCapUpdateRequestFlow(action) {
  const nhaCungCap = yield select(getNhaCungCapState);
  try {
    // grab the client from our action
    const result = yield call(nhaCungCapUpdateRequestApi, nhaCungCap.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nhaCungCapUpdateSuccess(result));
  } catch (error) {
    yield put(brActions.nhaCungCapUpdateError(error))
  }
}

function* nhaCungCapRemoveRequestFlow(action) {
  const nhaCungCap = yield select(getNhaCungCapState);
  try {
    // grab the client from our action
    const result = yield call(nhaCungCapRemoveRequestApi, nhaCungCap.formData)
    // dispatch the action with our widgets!
    yield put(brActions.nhaCungCapRemoveSuccess(result));
    if (typeof nhaCungCap.callback == 'function') {
      yield call(nhaCungCap.callback, result);
    }
  } catch (error) {
    yield put(brActions.nhaCungCapRemoveError(error))
  }
}

function* nhaCungCapWatcher() {
  yield [
    takeLatest(Constants.NHACUNGCAP_LIST_REQUESTING, nhaCungCapListRequestFlow),
    takeLatest(Constants.NHACUNGCAP_DETAIL_REQUESTING, nhaCungCapDetailRequestFlow),
    takeLatest(Constants.NHACUNGCAP_UPDATE_REQUESTING, nhaCungCapUpdateRequestFlow),
    takeLatest(Constants.NHACUNGCAP_REMOVE_REQUESTING, nhaCungCapRemoveRequestFlow),
  ]
}

export default nhaCungCapWatcher



// WEBPACK FOOTER //
// ./src/views/NhaCC/sagas.js